if (!customElements.get('ff-more-information')) {
  class FFMoreInformation extends HTMLElement {
    constructor() {
      super();
      this.modalId = this.getAttribute('id');
      this.closers = this.querySelectorAll('[data-ff-more-info-close]');
      this.openers = document.querySelectorAll(
        `[data-ff-more-info-open="${this.modalId}"]`
      );
      this._handleKeydown = this._handleKeydown.bind(this);
    }

    connectedCallback() {
      this.closers.forEach((el) => {
        el.addEventListener('click', () => this.closeModal());
      });

      this.openers.forEach((btn) => {
        btn.addEventListener('click', () => this.openModal());
      });

      // Auto-open si el form se renderizo con errores o exito tras submit
      const form = this.querySelector('form.ff-more-info-form');
      if (form && form.querySelector('.ff-more-info-form-message')) {
        this.openModal();
      }
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this._handleKeydown);
    }

    openModal() {
      this.classList.add('ff-more-info--open');
      this.removeAttribute('hidden');
      document.body.classList.add('ov-hidden');
      document.addEventListener('keydown', this._handleKeydown);
    }

    closeModal() {
      this.classList.remove('ff-more-info--open');
      this.setAttribute('hidden', '');
      document.body.classList.remove('ov-hidden');
      document.removeEventListener('keydown', this._handleKeydown);
    }

    _handleKeydown(event) {
      if (event.key === 'Escape') {
        this.closeModal();
      }
    }
  }

  customElements.define('ff-more-information', FFMoreInformation);
}
